import { useIntl } from 'react-intl';

import Metadata, { type MetadataProps } from './Metadata';

function NotfoundMetadata(props: MetadataProps) {
    const intl = useIntl();

    return (
        <Metadata
            title={intl.formatMessage({
                defaultMessage: 'Page introuvable',
                description: 'Page title',
            })}
            pageType="404"
            {...props}
        />
    );
}

export default NotfoundMetadata;
